import { CaretDownFilled, ClockCircleOutlined, UserOutlined, EnvironmentOutlined, CalendarOutlined, InfoCircleOutlined, FileTextOutlined } from "@ant-design/icons";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Form, Modal, Tag, Button, DatePicker, Space, message, Popconfirm, Tabs, Divider, Table, Alert } from "antd";
import React, { useEffect, useRef, useState,  } from "react";
import { ATTENTION_ASK, ReportAttentionAlert } from "./reportAttentionAlert";
import dayjs from "dayjs";
import { MobileResponseReport } from "./mobileResponseReport";
import { EditMobileTask } from "./editTask";
import Swal from "sweetalert2";
import { useLazyQuery, useMutation } from "@apollo/client";
import { cancelResponseByIdMutation, stopUntilFurtherNoticeByTemplateIdMutation } from "../../util/mutation/mobileServices.mutation";
import { useDispatch } from "react-redux";
import { setNotification } from '@src/middleware/redux/reducers/notification.reducer';
import TaskDetailsView from "./taskDetail";
import { CancelTaskModal } from "./cancelTaskModal";
import ActivityTab from "./activityTab";
import { GetSiteTerminationImpactQuery } from "@src/util/query/site.query";
import { SiteTerminationCheckModal } from "../site/siteDetailPage/component/siteTerminationCheckModal";



export const EditTaskMainModal = ({ visible, onClose, taskData, activeKey="overview" }) => {
  console.log(
    taskData, "taskData?.reportTemplateId"
  )
  const [activeTab, setActiveTab] = useState(activeKey);

  // In-review report the AI read flagged (the red row on Mobile Services): a full-screen
  // alert the first time the Report tab opens, and the note stays above the report.
  const attention = taskData?.status?.toLowerCase() === "in-review" && taskData?.reportAssessment?.needsAttention === true
    ? taskData.reportAssessment : null;
  const [attentionAlert, setAttentionAlert] = useState(false);
  const attentionShownRef = useRef(false);
  useEffect(() => {
    if (visible && activeTab === "response" && attention && !attentionShownRef.current) {
      attentionShownRef.current = true;
      setAttentionAlert(true);
    }
  }, [visible, activeTab, !!attention]);

  // Check if task is recurring
  const isRecurring = taskData?.scheduleType &&  taskData?.scheduleType=="ufn";

  // Check if task can be cancelled
  const canCancel = taskData?.status ? 
    !['inprogress', 'completed'].includes(taskData.status.toLowerCase()) : true;





  const getPriorityColor = (priority) => {
    const colors = {
      high: { bg: '#FF4D4F', text: '#ffffff' },
      medium: { bg: '#FA8C16', text: '#ffffff' },
      low: { bg: '#52C41A', text: '#ffffff' },
    };
    return colors[priority?.toLowerCase()] || { bg: '#f3f4f6', text: '#374151' };
  };

  const getStatusColor = (status) => {
    const colors = {
      cancel: { bg: '#f87171', text: '#ffffff' },
      assigned: { bg: '#e0e7ff', text: '#3730a3' },
      overdue: { bg: '#fee2e2', text: '#991b1b' },
      due: { bg: '#fef3c7', text: '#92400e' },
      "inprogress": { bg: '#cffafe', text: '#155e75' },
      completed: { bg: '#d1fae5', text: '#065f46' },
    };
    return colors[status?.toLowerCase()] || { bg: '#f3f4f6', text: '#374151' };
  };

  const dispatch = useDispatch();

  const [stopUntilFurtherNoticeByTemplateId, {loading: stopUntilFurtherNoticeByTemplateIdLoading}] = useMutation(stopUntilFurtherNoticeByTemplateIdMutation);

  // Same pre-termination gate the Site detail page's "Site Status ->
  // Terminated" save runs (see siteTerminationCheckModal.jsx) - this button
  // terminates the site's contract too (stopUntilFurtherNoticeByTemplateId
  // sets the site's sitestatus/contractenddate under the hood), so it needs
  // the same check for a still-rolling rota, guarding duties, other active
  // mobile templates, and outstanding keys before it's allowed to go
  // through. `pendingTermination` holds the date/reason/comments collected
  // by the Swal flow below until the user clears the check and hits
  // "Proceed with Termination".
  const [getSiteTerminationImpact, {loading: terminationCheckLoading}] = useLazyQuery(GetSiteTerminationImpactQuery, {fetchPolicy: 'network-only'});
  const [terminationImpact, setTerminationImpact] = useState(null); // {message, response} | null
  const [pendingTermination, setPendingTermination] = useState(null); // {stopDate, reason, comments} | null

  const refreshTerminationImpact = async ()=>{
    if(!pendingTermination?.stopDate) return;
    const res = await getSiteTerminationImpact({variables: {siteId: taskData?.siteDetail?._id, contractEndDate: pendingTermination.stopDate}});
    setTerminationImpact(res?.data?.getSiteTerminationImpact ?? null);
  };

  const handleProceedTermination = async (finalStatus)=>{
    try{
      await stopUntilFurtherNoticeByTemplateId({
        variables: {
          stopDate: pendingTermination?.stopDate,
          reason: pendingTermination?.reason,
          comments: pendingTermination?.comments,
          templateId: taskData?.templateId,
          isCancelled: true,
          siteStatus: finalStatus,
        }
      });

      setTerminationImpact(null);
      setPendingTermination(null);

      dispatch(setNotification({
        error: false,
        notificationState: true,
        message: "Task was stopped successfully",
      }));

      onClose();
    }catch(err){
      dispatch(setNotification({ error: true, notificationState: true, message: err?.message }));
    }
  };

  const handelStopTask = async ()=>{
    
    const stopResult = await Swal.fire({
      title: "Terminate Site Contract?",
      text: "This will stop the site contract service and cancel any tasks after the selected date.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, stop",
      cancelButtonText: "No",

      confirmButtonColor: "#d33",
      cancelButtonColor: "#6c757d",
    });
    
    if (!stopResult.isConfirmed) return;
    const dateResult = await Swal.fire({
      title: "Select Termination Date",
      html: `


        <select id="reasonSelect" class="swal2-select" style="width:100%;margin:10px">
          <option value="">Select reason</option>
          <option value="Contract Ended">Contract Ended</option>
          <option value="Site Closed">Site Closed</option>
          <option value="Client Terminated">Client Terminated</option>
          <option value="Non-payment">Non-payment</option>
          <option value="Other">Other</option>
        </select>

        
        <input
          id="otherComment"
          class="swal2-input"
          placeholder="Please specify..."
          style="display:none;margin:10px; width:100%;"
        />


        <input
            type="date"
            id="stopDate"
            class="swal2-input"
            style="width:100%;margin:10px"
            min="${new Date().toLocaleDateString('en-CA')}"
        />

        <p style="font-size:13px;color:#666">
          Tasks will stop after this date, and the site will be marked as terminated.
        </p>


      `,
    
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: "Continue",
      confirmButtonColor: "#d33",
      cancelButtonColor: "#6c757d",
    
      didOpen: () => {
        const select = document.getElementById("reasonSelect");
        const comment = document.getElementById("otherComment");
    
        select.addEventListener("change", () => {
          if (select.value === "Other") {
            comment.style.display = "inline";
          } else {
            comment.style.display = "none";
            comment.value = "";
          }
        });
      },
    
      preConfirm: () => {
        const date = document.getElementById("stopDate").value;
        const reason = document.getElementById("reasonSelect").value;
        const comment = document.getElementById("otherComment").value.trim();
    
        if (!date) {
          Swal.showValidationMessage("Please select a termination date");
          return false;
        }

        // if(date && dayjs(date).isBefore(dayjs())){
        //   Swal.showValidationMessage("Please select a valid termination date");
        //   return false;

        // }
    
        if (!reason) {
          Swal.showValidationMessage("Please select a reason");
          return false;
        }
    
        if (reason === "Other" && !comment) {
          Swal.showValidationMessage("Please provide a comment for 'Other'");
          return false;
        }
    
        return {
          stopDate: date,
          reason,
          comments: reason === "Other" ? comment : null
        };
      }
    });
    
    if (!dateResult.isConfirmed) return;

    const { stopDate, reason, comments } = dateResult.value || {};
    if(!stopDate) return;

    setPendingTermination({ stopDate, reason, comments });
    const res = await getSiteTerminationImpact({variables: {siteId: taskData?.siteDetail?._id, contractEndDate: stopDate}});
    setTerminationImpact(res?.data?.getSiteTerminationImpact ?? null);
  };

  const [cancelTaskModal, setCancelTaskModal] = useState({modal: false, taskId:null, templateId: null});

  const handleCancelTask = async (taskId, templateId) => {
    setCancelTaskModal({modal: true, taskId: taskId, templateId: templateId});

  };
  
  
  // Overview Tab Content
  const OverviewTab = () => (
    <TaskDetailsView taskData={taskData} onClose={onClose} 
      getPriorityColor={getPriorityColor}
      getStatusColor={getStatusColor}
      stopUntilFurtherNoticeByTemplateIdLoading={stopUntilFurtherNoticeByTemplateIdLoading}
      handelStopTask={handelStopTask}
      canCancel={canCancel}
      cancelResponseLoading={false}
      handelCancelTask={handleCancelTask}
      isRecurring={isRecurring}
    />
  );
  

  // Edit Tab Content
  const EditTab = () => (
    <EditMobileTask key={taskData?._id} taskData={taskData} onClose={onClose} />
  );

  // Officer Response Tab Content
  const OfficerResponseTab = () => (
    <>
    {attention && (
      <Alert
        type="error"
        showIcon
        style={{ marginBottom: 16 }}
        message="Needs attention"
        description={<>{attention.reason && <div style={{ fontWeight: 600 }}>{attention.reason}</div>}<div>{ATTENTION_ASK}</div></>}
      />
    )}
    <MobileResponseReport
      templateId={taskData?.reportTemplateId}
      jobData={
        {
          siteId: taskData?.siteDetail?._id,
          jobId: taskData?._id,
          isReportSubmitted: taskData?.isReportSubmitted,
          sitename:  taskData?.siteDetail?.sitename,
          customerId: taskData?.customerDetail?._id
        }
      }

    />
    </>
  );

  const tabItems = [
    {
      key: 'overview',
      label: 'Overview',
      children: <OverviewTab />
    },
    {
      key: 'edit',
      label: 'Edit Task',
      children: <EditTab key={taskData?._id} />
    },
    {
      key: 'response',
      label: 'Report',
      children: <OfficerResponseTab />
    },
    {
      key: 'activity',
      label: 'Activity Logs',
      children: <ActivityTab key={taskData?._id} taskData={taskData} />
    }
  ];

  return (
    <>
      <Modal
        open={visible}
        footer={
            null
        }
        closable={false}
        width="80%"
        style={{top:2}}
      >
        {/* Header */}

        <div className='modal-header-title' style={{padding:'16px 40px'}}>
            <span style={{letterSpacing:'0.2px'}}> 
                Task Management
                <p style={{ 
                  fontSize: '13px', 
                  margin: '4px 0 0 0' 
                }}>
                  View details, edit task information, and manage report
                </p>
            </span>
            <span  onClick={async()=>{onClose()}}><FontAwesomeIcon className='close' icon={faClose}/></span>
        </div>


        
        <div className='modal-body-padding' style={{overflow: 'auto', maxHeight:'85vh'}}>


        <div className="setting-body editDutyModal-sm" style={{ margin:0, padding:0, flex:'auto', width: '100%', maxWidth:'100%', zIndex:2} }>
            <div className="setting-body-inner" style={{margin:0, padding:0}}>
              {/* Tabs */}
              <Tabs
                className="edit-tabs"
                activeKey={activeTab}
                onChange={setActiveTab}
                items={tabItems}
                />

            </div>
        </div>


        </div>
      </Modal>

      {/* Stop Recurrence Modal */}

      {
        cancelTaskModal.modal?
        <CancelTaskModal
          visible={cancelTaskModal.modal}
          templateId={cancelTaskModal.templateId}
          taskId={cancelTaskModal.taskId}
          onClose={()=>{setCancelTaskModal({modal: false, taskId: null, templateId: null}); onClose();}}

        />
        :null
      }

      {
        attentionAlert && attention &&
        <ReportAttentionAlert
          reason={attention.reason}
          sitename={taskData?.siteDetail?.sitename}
          assignee={
            taskData?.employeeDetail
              ? [taskData.employeeDetail.firstname, taskData.employeeDetail.lastname].filter(Boolean).join(" ")
              : taskData?.supplierDetail?.suppliername
          }
          onAcknowledge={() => setAttentionAlert(false)}
        />
      }

      <SiteTerminationCheckModal
        open={!!terminationImpact}
        siteId={taskData?.siteDetail?._id}
        contractEndDate={pendingTermination?.stopDate}
        impact={terminationImpact}
        checking={terminationCheckLoading || stopUntilFurtherNoticeByTemplateIdLoading}
        onRefresh={refreshTerminationImpact}
        onCancel={()=>{setTerminationImpact(null); setPendingTermination(null);}}
        onProceed={handleProceedTermination}
      />



    </>
  );
};



